<ng-container (keydown.esc)="closeModal('ESC pressed')">
  <div class="d-flex card-header text-center bg-dark bg-gradient text-white">
    <b class="flex-fill m-auto">Closure Product Specifications</b>   
    <button type="button" class="close border-0 bg-transparent h4 text-white" aria-describedby="modal-title" (click)="closeModal('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <app-closure-specifications [showHeader]="false"
                              [showLoader]="(closureLoader$ | async) || false"
                              [product]="(activeClosure$ | async) || undefined"
                              [hasDrawing]="(closureFlatterFilesIntegrationIsEnabled$|async) ? ((activeClosure$|async)?.drawings || []).length > 0 : ((closureHasDrawing$ | async) || false)"
                              (getClosureDrawing)="onGetClosureFile($event)"
                              ></app-closure-specifications>
</ng-container>